import { useMemo } from "react";
import { useStore } from "utils/store";

export const useSkinnedAssets = () => {
  const skin = useStore(state => state.skin);

  const directory = useMemo(() => {
    switch(skin) {
      case 'acr':
        return '/acr';
      default:
        return '/default';
    }
  }, [skin]);

  return {
    bgDesktop: `images${directory}/bg0.webp`,
    bgMobile: `images${directory}/bg0-mobile.webp`,
    logoHorizontal: `images${directory}/logo-horizontal.png`,
    logoMobile: `images${directory}/logo-mobile.png`,
    logo: `images${directory}/logo.png`,
    logoSidebar: `images${directory}/sidebar-logo.png`,
    thumbnail: `images${directory}/thumbnail.jpg`,
    header: `images${directory}/time-machine-header.png`,
  }
};